import { createSelector } from 'reselect';
import { PlaygroundSubsection } from '../../types/store';
import { getStudioSlice } from './page';

export const getPlaygroundSubsection = createSelector(
  [getStudioSlice],
  state => state.playground?.subsection ?? PlaygroundSubsection.NotMounted
);

export const getIsDrawingTabVisible = createSelector(
  [getStudioSlice],
  state => !!state.playground.isDrawingsTabVisible
);
